import React from "react"
import { hydrateRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { loadableReady } from "@loadable/component"
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { preparedRoutes } from "@routes"
import initalizeSentry from "@lib/sentry"

import "./styles"
import configureStore from "@store"

// Render the application
window.addEventListener("load", () => {
    loadableReady(() => {
        const { __STATUS_CODE__: status, __INITIAL_STATE__ } = window
        const store = configureStore(__INITIAL_STATE__) // Hydrate the redux store from server state.
        const routes = preparedRoutes({ code: status })
        const router = createBrowserRouter(routes)
        initalizeSentry()
        const Application = (
            <Provider store={store} serverState={__INITIAL_STATE__}>
                <React.StrictMode>
                    <RouterProvider router={router} />
                </React.StrictMode>
            </Provider>
        )
        delete window.__INITIAL_STATE__
        delete window.__STATUS_CODE__
        const container = document.getElementById("app")
        hydrateRoot(container, Application)
    })
})
